import React from 'react';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';

function CustomTooltip({ active, payload, label }) {
  if (!active || !payload?.[0]) return null;
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-xs shadow-xl">
      <p className="text-slate-400 mb-1">{label}</p>
      <p className="text-purple-300">Calls: {payload[0].value}</p>
      {payload[1] && <p className="text-orange-300">Burned: {payload[1].value}</p>}
    </div>
  );
}

export default function SettlementChart({ history }) {
  // Generate sample data if no history provided
  const data = history && history.length > 0 ? history : generateSampleData();

  return (
    <div className="bg-slate-900/60 border border-slate-800 rounded-xl p-3 sm:p-4 overflow-hidden">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-xs text-slate-500 uppercase tracking-wider">Settlement History</h3>
        <div className="flex items-center gap-3 text-[10px]">
          <span className="flex items-center gap-1.5">
            <span className="w-3 h-1 rounded-full bg-purple-500"></span>
            Calls
          </span>
          <span className="flex items-center gap-1.5">
            <span className="w-3 h-1 rounded-full bg-orange-500"></span>
            Burned
          </span>
        </div>
      </div>
      <div className="h-48">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data} margin={{ top: 5, right: 5, bottom: 0, left: -20 }}>
            <defs>
              <linearGradient id="callsGrad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#8b5cf6" stopOpacity={0.3} />
                <stop offset="95%" stopColor="#8b5cf6" stopOpacity={0} />
              </linearGradient>
              <linearGradient id="burnGrad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#f97316" stopOpacity={0.3} />
                <stop offset="95%" stopColor="#f97316" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#1e293b" />
            <XAxis dataKey="label" tick={{ fontSize: 10, fill: '#475569' }} axisLine={false} tickLine={false} />
            <YAxis tick={{ fontSize: 10, fill: '#475569' }} axisLine={false} tickLine={false} />
            <Tooltip content={<CustomTooltip />} />
            <Area type="monotone" dataKey="calls" stroke="#8b5cf6" fill="url(#callsGrad)" strokeWidth={2} />
            <Area type="monotone" dataKey="burned" stroke="#f97316" fill="url(#burnGrad)" strokeWidth={1.5} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

function generateSampleData() {
  // Show realistic-looking data based on devnet activity
  return [
    { label: 'Mar 29', calls: 0, burned: 0 },
    { label: 'Mar 29', calls: 5, burned: 0 },
    { label: 'Mar 30', calls: 12, burned: 0 },
    { label: 'Mar 30', calls: 20, burned: 0 },
    { label: 'Mar 30', calls: 5, burned: 360 },
    { label: 'Mar 30', calls: 8, burned: 0 },
  ];
}
